'use client';
import { useState } from "react";
import { Span } from 'themes/jumbo/@jumbo/shared';
import SettingsIcon from '@mui/icons-material/Settings';
import { blue } from '@mui/material/colors';
import { useDispatch, useSelector } from 'react-redux';
import { openDialog } from 'store/main/userSettingsDialog';
import DeleteIcon from '@mui/icons-material/Delete';
import { RootState } from 'store';
import { Grid } from "@mui/material";
import styles from "themes/jumbo/app/_components/user/profile/components/About/About.module.css";
import AuthService from "services/AuthService";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Button} from "@mui/material";
import { updateActiveUser, updateMaxUser, updateTeam } from 'store/main/userManagement';
import jwtService from 'services/jwtService';
import { trackEvent } from "./Tracking";

import {
  Avatar,
  Card,
  Stack,
  Typography,
  styled,
} from '@mui/material';
import UserSettings from "./UserSettings";

const Item = styled(Span)(({ theme }) => ({
  padding: theme.spacing(0, 1),
}));

type UserProps = {
    email : string,
    ipn_name : string,
    status : string,
	id: string
}

const UserTeam = ({ item, subscription_status }: { item: UserProps, subscription_status:any }) => {

	const {email, status, ipn_name, id} = item
	const [showConfirm, setShowConfirm] = useState(false)
	const [userID, setUserID] = useState('')
	const dispatch = useDispatch();
	const [plan, setPlan] = useState([])
	const state = useSelector((state:RootState) => state.main.settings.state)
	const options = useSelector((state:RootState) => state.main.settings.options);

	const handleUserSettings = (e:any, id:string, email:string) => {
		e.preventDefault()
		dispatch(openDialog({email : email, id: id}))
	}

	const handleCloseDelete = () => {
        setShowConfirm(false)
    }

	const getPlan = async () => {
        const endpoint = process.env.REACT_APP_BASE_URL + '/subscription/email';
		try{
			let response = await jwtService.fetchRequest({
                method: 'POST',
                url: endpoint,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                data: {email : btoa(AuthService.userEmail), key_id : process.env.REACT_APP_BASE_APIKEY}
            });

			if(response.data){
				const result = response.data
				setPlan(result.data) 
           		if(typeof result.data[0] !== "undefined"){
					dispatch(updateMaxUser(result.data[0]['ipn_qty']))
					dispatch(updateActiveUser(result.data[0]['active_users']))
				}  
			}

		}catch(e){
			console.log(e)
		}
    }

	const getMyTeam = async () => {
        try{
            const endpoint = process.env.REACT_APP_BASE_URL + '/v2/customer/myusers';
            let response = await jwtService.fetchRequest({
                method: 'POST',
                url: endpoint,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                "data": {email : btoa(AuthService.userEmail), key_id : process.env.REACT_APP_BASE_APIKEY}
            });
            
            if(response.data){
                dispatch(updateTeam(response.data.data))  
            }
		}catch(err){
            console.log(err);
        }
    }

	const confirmDeleteRequest = async () => {
        
		setShowConfirm(false);
		try{
			const endpoint = process.env.REACT_APP_BASE_URL + '/v2/user/delete';
			let response = await jwtService.fetchRequest({
				method: 'POST',
				url: endpoint,
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
				},
				"data": {id : userID, key_id : process.env.REACT_APP_BASE_APIKEY}
			});

			if(response.data) {
				getMyTeam()
				getPlan()
			}
		}catch(e){
			console.log(e)
		}      
    };

	const deleteUser = (id:string) => {
		setUserID(id)
		setShowConfirm(true);
	}

	return (
		<>
		<Dialog
                sx={{
                    '& .MuiPaper-root': {
                    backgroundColor: 'transparent', // Custom background color
                    },
                    '& .MuiDialog-paper': {
                        backgroundColor: '#fff !important',  // Change to your desired color
                    },
                }}
                open={showConfirm}
                onClose={handleCloseDelete}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">User deletion</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleCloseDelete}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                    >
                    <CloseIcon />
                </IconButton>
                <DialogContent>
                    <DialogContent id="alert-dialog-description">
                    Do you really want to delete this user and all his projects?
                    </DialogContent>
                </DialogContent>
                <DialogActions>
                    <Button onClick={confirmDeleteRequest} color="primary">
                    Yes
                    </Button>
                    <Button onClick={handleCloseDelete} color="primary">
                    No
                    </Button>
                </DialogActions>
            </Dialog>
		{state ? 
		<UserSettings email={options.email} id={options.id}/>
		:
		''
		}
		<Card sx={{ mb: 1}} >
			<Grid container spacing={2} className={styles.stackcontainer}>
				<Grid item xs={5}>
					<Stack className={styles.responsivestack}>
						<Item>
							<Avatar sx={{ bgcolor: blue[100], color: blue[600], width: 46, height: 46,}} />
						</Item>
						<Item
						className={styles.responsivestackitem}
						>
							<Typography
								variant={'h6'}
								mb={0.5}
							>{`${email}`}
							</Typography>
						</Item>
					</Stack>
				</Grid>
				<Grid item xs={subscription_status === 'ACTIVE' ? 3 : 4}>
				
						<Typography
							variant={'h6'}
								mb={0.5}
							>{`${ipn_name}`}
						</Typography>
					
				</Grid>
				<Grid item xs={subscription_status === 'ACTIVE' ? 2 : 3}>
					<Item>
					<Typography
							variant={'h6'}
							mb={0.5}
						>{`${status}`}
					</Typography>
					</Item>
				</Grid>
				{
				subscription_status === 'ACTIVE' ? 
				<>
				<Grid item xs={1}>
					<Item
						sx={{
							ml: 'auto',
							display: { xs: 'none', sm: 'block' },
							cursor : 'pointer'
						}}
						onClick={() => {
							trackEvent("UserProfile", "My Team", "Delete");
							deleteUser(`${id}`);
						}}
						>
						<Typography
							variant={'h6'}
							mb={0.5}
						>
							<DeleteIcon color="secondary"/>
						</Typography>
					</Item>
				</Grid>
				<Grid item xs={1}>
					<Item
						sx={{
							ml: 'auto',
							display: { xs: 'none', sm: 'block' },
							cursor : 'pointer'
						}}
						onClick={(e) => {
							trackEvent("UserProfile", "My Team", "Settings");
							handleUserSettings(e, `${id}`, `${email}`);
						}}
						>
						<Typography
							variant={'h6'}
							mb={0.5}
						>
							<SettingsIcon sx={{color:'#3DABE6'}}/>
						</Typography>
					</Item>
				</Grid>
				</>
				: ''
				}
			</Grid>
		</Card>
		</>
  	);
};

export { UserTeam };
